import React, {  Component } from 'react';

export default class TrackOrderOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('TrackOrderOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="trackOrderOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                <a className="closeButton fontSize-10" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Track Order</h2>
					<table className="trackOrderTable formTableTypeA">
				        <tbody>
							<tr>
					            <td>
					              CSO (Order number):
					            </td>
					            <td>
					              11111111
					            </td>
					          	</tr>
					          	<tr>
					            <td>
					              Status:
					            </td>
					            <td>
					              Order is being processed by Customer Service.<br />
					              Please contact Customer Service for additional details.
					            </td>
				          	</tr>
				        </tbody>
					</table>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/trackOrderOverlayDialog.js